export enum LengthUnit {
    METER,
    DECIMETER,
    CENTIMETER,
    MILLIMETER,
    INCH,
    PT
}
